import Axios from "axios";

const CHAVE_STORAGE = "servicobusca_smarthint_session";
let renovacaoPendente = null;

function ler() {
    try {
        const valorArmazenado = localStorage.getItem(CHAVE_STORAGE);

        if (!valorArmazenado) {
            return null;
        }

        const sessao = JSON.parse(valorArmazenado);
        return sessao && typeof sessao === "object" ? sessao : null;
    } catch (e) {
        remover();
        return null;
    }
}

function remover() {
    try {
        localStorage.removeItem(CHAVE_STORAGE);
    } catch (e) {
        return;
    }
}

function normalizarTexto(valor) {
    const texto = String(valor == null ? "" : valor).trim();
    return texto !== "" ? texto : null;
}

function obterExpiracaoEmMilissegundos(expiracao) {
    if (expiracao == null || expiracao === "") {
        return null;
    }

    const expiracaoNumerica = Number(expiracao);

    if (isFinite(expiracaoNumerica) && expiracaoNumerica > 0) {
        return expiracaoNumerica < 1000000000000
            ? expiracaoNumerica * 1000
            : expiracaoNumerica;
    }

    const expiracaoData = Date.parse(expiracao);
    return isNaN(expiracaoData) ? null : expiracaoData;
}

function obterContextoValido(sessao) {
    if (!sessao) {
        return null;
    }

    const valor = normalizarTexto(sessao.valor);
    const anonymousConsumer = normalizarTexto(sessao.anonymousConsumer);
    const expiracao = obterExpiracaoEmMilissegundos(sessao.expiracao);

    if (!valor || !anonymousConsumer || !expiracao || expiracao <= Date.now()) {
        return null;
    }

    return {
        valor,
        anonymousConsumer
    };
}

function obterUrlSessao() {
    if (window.servicobusca && window.servicobusca.urlSessao) {
        return window.servicobusca.urlSessao;
    }

    throw new Error("URL da sessão do serviço de busca não configurada.");
}

function salvarSessao(dados) {
    const sessao = {
        valor: dados.valorSessao,
        expiracao: dados.dhExpiracao,
        anonymousConsumer: dados.SmartHint_AnonymousConsumer
    };

    const contexto = obterContextoValido(sessao);

    if (!contexto) {
        throw new Error("Sessão inválida retornada pelo serviço de busca.");
    }

    localStorage.setItem(CHAVE_STORAGE, JSON.stringify(sessao));
    return contexto;
}

function renovar() {
    if (renovacaoPendente) {
        return renovacaoPendente;
    }

    renovacaoPendente = Axios.get(obterUrlSessao()).then((response) => {
        renovacaoPendente = null;
        return salvarSessao(response.data || {});
    }, (error) => {
        renovacaoPendente = null;
        return Promise.reject(error);
    });

    return renovacaoPendente;
}

function obterContexto() {
    const contexto = obterContextoValido(ler());

    if (contexto) {
        return Promise.resolve(contexto);
    }

    remover();
    return renovar();
}

function salvarSearchId(searchId) {
    const searchIdNormalizado = String(searchId == null ? "" : searchId).trim();

    if (searchIdNormalizado === "") {
        return;
    }

    const sessao = ler();

    if (!sessao || sessao.searchId === searchIdNormalizado) {
        return;
    }

    sessao.searchId = searchIdNormalizado;

    try {
        localStorage.setItem(CHAVE_STORAGE, JSON.stringify(sessao));
    } catch (e) {
        return;
    }
}

function obterSearchId() {
    const sessao = ler();
    return normalizarTexto(sessao && sessao.searchId) || "";
}

export default {
    obterContexto,
    obterSearchId,
    salvarSearchId
};
